import React from 'react';
import { Link } from 'react-router-dom';
import VectorBackground from '../common/VectorBackground';

const Home = () => {
    const title = "Welcome to PlanMaster";

    return (
        <div className="relative flex flex-col items-center justify-center h-full pt-16 px-4 text-gray-800 dark:text-gray-200">
            <VectorBackground />
            <div className="relative z-10 text-center w-full max-w-lg opacity-0 animate-fade-in">
                <h1 className='flex justify-center text-4xl sm:text-5xl font-playwrite font-medium mb-8 text-gray-900 dark:text-gray-100'>
                    {title.split("").map((char, index) => (
                        <span
                            key={index}
                            className="opacity-0 animate-letter-fade"
                            style={{ animationDelay: `${1.5 + index * 0.05}s` }}
                        >
                            {char === " " ? "\u00A0" : char}
                        </span>
                    ))}
                </h1>
                
                <Link
                    to="/projects"
                    className="px-8 py-3 bg-blue-600 text-white font-playwrite font-semibold text-lg rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-300"
                >
                    Go to Projects
                </Link>
            </div>
        </div>
    );
}

export default Home;
